module.exports = __webpack_public_path__ + "img/kia_thumbnail.69742847.png";